<template>
  <label
    class="block font-inter text-xs font-medium leading-6 text-gray-200 transition duration-300 group-focus-within/input:!text-gray-100 group-focus-within:!text-gray-100 group-hover:text-gray-100 dark:group-focus-within/input:!text-gray-100"
    :class="{
      '!text-gray-100': opened || changed,
      '!text-gray-300': disabled,
      'no-margin': noMargin,
      'flex items-center': tip || changed || reserveReset,
      'after:ml-1.5 after:inline-block after:h-[7px] after:w-[7px] after:rounded-full after:bg-accent-1 after:opacity-50':
        changed && disabled,
    }"
    :for="forId"
  >
    <slot />

    <TTip v-if="tip && tip !== ''" :tip="tip" />
    <!--
      With reserveReset the cross always occupies a narrow 14px slot between
      the content and the input and is only made invisible while unchanged.
      The slot doubles as the spacing to the input, so showing the cross never
      shifts anything. The 20px hit area (this div) is pulled 6px left over
      the label content, so it never overlaps the input, while the SVG is
      shifted back so the glyph stays centred in the slot. The SVG ignores
      pointer events, so its overhang over the input is not clickable. The
      hidden placeholder carries no test id, so "no reset offered" assertions
      keep working.
    -->
    <div
      v-if="showReset || reserveReset"
      class="cursor-pointer text-accent-1 opacity-75 hover:opacity-100"
      :class="{
        'invisible pointer-events-none': reserveReset && !showReset,
        '-ml-1.5 h-5 w-5 shrink-0': reserveReset,
      }"
      v-tooltip="{
        content: tooltip,
      }"
      :data-testid="showReset ? 'reset-label' : undefined"
      @click.stop.prevent="$emit('reset')"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="{ 'pointer-events-none translate-x-[3px]': reserveReset }"
      >
        <path
          d="M13.5156 8.03906C13.8203 7.75781 13.8203 7.26562 13.5156 6.98438C13.2344 6.67969 12.7422 6.67969 12.4609 6.98438L10 9.44531L7.51562 6.98438C7.23438 6.67969 6.74219 6.67969 6.46094 6.98438C6.15625 7.26562 6.15625 7.75781 6.46094 8.03906L8.92188 10.5L6.46094 12.9844C6.15625 13.2656 6.15625 13.7578 6.46094 14.0391C6.74219 14.3438 7.23438 14.3438 7.51562 14.0391L10 11.5781L12.4609 14.0391C12.7422 14.3438 13.2344 14.3438 13.5156 14.0391C13.8203 13.7578 13.8203 13.2656 13.5156 12.9844L11.0547 10.5L13.5156 8.03906Z"
          fill="currentColor"
        />
      </svg>
    </div>
  </label>
</template>
<script lang="ts" setup>
import TTip from "../TTip/TTip.vue";
import { computed, ref } from "vue";

const props = defineProps<{
  for?: string;
  opened?: boolean;
  disabled?: boolean;
  noMargin?: boolean;
  tip?: string;
  changed?: boolean;
  tooltip?: string;
  /**
   * Keep a fixed slot for the reset cross even while unchanged. Meant for
   * labels sitting inline right before their input; the slot replaces the gap.
   */
  reserveReset?: boolean;
}>();

defineEmits(["reset"]);

const forId = ref(props.for);
const showReset = computed(() => props.changed && !props.disabled);
</script>
